<template>
  <div class="add-contract-temp">
    <div v-if="contractAiLoading" class="contract-ai-loading-mask">
      <div class="contract-ai-loading-panel">
        <div class="contract-ai-loading-spinner" />
        <div class="contract-ai-loading-title">AI 正在解析合同</div>
        <div class="contract-ai-loading-text">AI解析中，预计需要30秒左右，请不要关闭浏览器。</div>
      </div>
    </div>
    <div v-if="isNextStepSaving" class="contract-ai-loading-mask">
      <div class="contract-ai-loading-panel">
        <div class="contract-ai-loading-spinner" />
        <div class="contract-ai-loading-title">保存合同中，请稍后</div>
      </div>
    </div>
    <QS-scroller-box>
      <QS-h3-title>
        <template #title>
          {{ pageTitle }}
        </template>
      </QS-h3-title>
      <div v-if="needLeasePlanStep" class="contract-stepper">
        <div
          class="contract-step"
          :class="{ active: currentStep === 1, completed: currentStep > 1 }"
        >
          <div class="contract-step-number">1</div>
          <div class="contract-step-label">上传合同</div>
        </div>
        <div class="contract-step-line" />
        <div
          class="contract-step"
          :class="{ active: currentStep === 2 }"
        >
          <div class="contract-step-number">2</div>
          <div class="contract-step-label">确认租赁方案</div>
        </div>
      </div>
      <div class="splitline mt16 mb16" />
      <div v-show="currentStep === 1" class="temp_content">
        <!-- 是否有效合同 -1识别中0无效1有效 无效时展示无效文案 -->
        <div class="temp_content_header" v-if="validResult.valid === 0 && !isCopy">
          <div class="ai-error-tip">
            <div class="ai-tag-wrapper">
              <span class="ai-prefix">AI</span>
              <span class="ai-suffix">检测失败</span>
            </div>
            <div class="error-text">{{ validResult.reason }}</div>
          </div>
        </div>
        <div class="temp_content_header">
          <div class="form-box">
            <el-tabs v-model="activeTab" type="card"
            v-if="this.moduleName === contractTemplateModule.entrustWithholdContractTemplate">
              <el-tab-pane name="1">
                <template #label>
                  <span>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="合同条款区可支持用户根据公司法务要求进行条款内容及样式修改！"
                      placement="top-end"
                    >
                      <i class="QS-icon-info"></i>
                    </el-tooltip>合同条款区域
                  </span>
                </template>
                <div class="contract-template-row">
                  <el-form inline>
                    <el-form-item label="合同模板名称:" required>
                      <el-input
                        v-model="contractName"
                        placeholder="请输入"
                        clearable
                      />
                    </el-form-item>
                  </el-form>
                  <div class="contract-import-actions">
                    <input
                      ref="docxInput"
                      class="docx-input"
                      type="file"
                      :accept="docxAcceptTypes"
                      @change="handleDocxSelected"
                    >
                    <el-button
                      size="small"
                      icon="el-icon-upload2"
                      :loading="contractImport.converting"
                      :disabled="contractImport.parsing"
                      @click="triggerDocxUpload()"
                    >上传 docx 合同</el-button>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="扣款方案配置区" name="2">
                <template #label>
                  <span>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="扣款方案配置区为固定模板内容不可修改，此处内容会根据扣款方案自动生成，若有疑问请联系平台工作人员！"
                      placement="top-end"
                    >
                      <i class="QS-icon-info"></i>
                    </el-tooltip> 扣款方案配置区
                  </span>
                </template>
              </el-tab-pane>
            </el-tabs>
            <el-form inline v-else>
              <div class="contract-template-row">
                <el-form-item label="合同模板名称:" required>
                  <el-input
                    v-model="contractName"
                    placeholder="请输入"
                    clearable
                  />
                </el-form-item>
                <div class="contract-import-actions">
                  <input
                    ref="docxInput"
                    class="docx-input"
                    type="file"
                    :accept="docxAcceptTypes"
                    @change="handleDocxSelected"
                  >
                  <el-button
                    size="small"
                    icon="el-icon-upload2"
                    :loading="contractImport.converting"
                    :disabled="contractImport.parsing"
                    @click="triggerDocxUpload()"
                  >上传 docx 合同</el-button>
                </div>
              </div>
            </el-form>
          </div>
        </div>
        <div v-if="activeTab === '1'" class="contract-editor-tip">
          请核查 AI 自动替换的字段是否准确，点击字段可定位到原文位置
        </div>
        <div class="editor-container" >
          <div class="edit">
            <TinymceVue :options="tinymceOptions"/>
            <div class="contract-editor-stats">
              占位符数量：{{ contentStats.placeholderCount }} | 内容长度：{{ contentStats.textLength }} 字符
            </div>
          </div>
          <section class="editor-box" v-if="isShowRightOption">
            <div class="replaced-field-panel">
              <div class="editor-box-header replaced-field-title">
                已替换字段
                <span class="replaced-field-count">{{ replacedFields.length }}</span>
              </div>
              <el-collapse v-model="replacedFieldCollapse">
                <el-collapse-item
                  :title="`已替换字段（${replacedFields.length}）`"
                  name="replacedFields"
                >
                  <div v-if="!replacedFields.length" class="replaced-empty">
                    暂无已替换字段
                  </div>
                  <div v-else class="replaced-field-list">
                    <div
                      v-for="item in replacedFields"
                      :key="item.id"
                      class="replaced-field-item"
                    >
                      <div class="replaced-field-info">
                        <span class="replaced-field-name">{{ item.fieldName }}</span>
                        <span class="replaced-field-group">{{ item.groupName || '--' }}</span>
                        <span
                          class="replaced-field-value"
                          :title="item.fieldValue || item.sourceText || item.displayLabel"
                        >
                          {{
                            getShortText(item.fieldValue || item.sourceText || item.displayLabel)
                          }}
                        </span>
                      </div>
                      <el-button
                        type="text"
                        size="mini"
                        @click.stop="locateReplacedField(item)"
                      >查看</el-button>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
            <div class="editor-box-header system-field-title">
              选取系统字段 <span>点击字段添加到编辑区光标处</span>
            </div>
            <el-collapse v-model="checkItems">
              <el-collapse-item
                v-for="(item, index) in keywords"
                :key="item.title"
                :title="item.title"
                :name="item.title"
              >
                <div class="box">
                  <div
                    v-for="(item, ind) in item.children"
                    :key="item.name"
                    class="check-item"
                  >
                    <span @click="handleClickSystemVar(index, ind)">
                      ${ {{ item.name }} }
                      <el-tooltip
                        v-if="item.explain"
                        class="item"
                        effect="dark"
                        :content="item.explain"
                        placement="top-end"
                      >
                        <i class="QS-icon-info"></i>
                      </el-tooltip>
                    </span>
                    <span v-if="item.type === 'string'">{{ item.example }}</span>
                    <img v-if="item.type === 'list'" :src='exmUrl'/>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </section>
        </div>
      </div>
      <LeasePlanForm
        v-if="needLeasePlanStep"
        v-show="currentStep === 2"
        ref="leasePlanForm"
        :contract-name="contractName"
      />

      <template #bottomAction>
        <div>
          <el-button size="small" @click="pageGoBack()">取消</el-button>
          <el-button
            v-if="currentStep === 1"
            :loading="oLoading.saveDraft"
            @click="handleSubmit('saveDraft')"
            size="small"
          >
            保存草稿
          </el-button>
          <el-button
            v-if="showStartAiParseButton"
            size="small"
            type="primary"
            :loading="contractImport.parsing"
            :disabled="contractImport.converting"
            @click="handleStartAiParseFromPaste"
          >开始AI智能解析</el-button>
          <el-button
            v-if="currentStep === 2"
            size="small"
            @click="goToContractStep()"
          >上一步</el-button>
          <el-button
            v-if="currentStep === 1 && isPermissionAdd"
            :loading="oLoading.add"
            @click="handleSubmit"
            size="small"
            type="primary"
          >下一步</el-button>
          <el-button
            v-if="currentStep === 1 && isEdit"
            :loading="oLoading.edit"
            @click="handleSubmit"
            size="small"
            type="primary"
          >保存</el-button>
          <el-button
            v-if="currentStep === 2"
            :loading="oLoading.submitLeasePlan"
            @click="submitLeasePlan"
            size="small"
            type="primary"
          >提交</el-button>
        </div>
      </template>
    </QS-scroller-box>
    <el-dialog
      :visible="placeholderDialog.visible"
      @update:visible="handlePlaceholderDialogVisibleChange"
      title="配置占位符"
      custom-class="placeholder-config-dialog"
      width="440px"
      append-to-body
    >
      <el-form
        class="placeholder-config-form"
        label-position="top"
        size="small"
      >
        <el-form-item label="字段分组">
          <el-input v-model="placeholderDialog.groupName" readonly />
        </el-form-item>
        <el-form-item label="字段名称">
          <el-input v-model="placeholderDialog.fieldName" readonly />
        </el-form-item>
        <el-form-item label="字段值">
          <el-input v-model="placeholderDialog.fieldValue" />
        </el-form-item>
        <el-form-item label="显示标签">
          <el-input v-model="placeholderDialog.displayLabel" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="small" @click="closePlaceholderDialog">取消</el-button>
        <el-button
          size="small"
          type="danger"
          @click="restorePlaceholder"
        >还原</el-button>
        <el-button
          size="small"
          type="primary"
          @click="savePlaceholderConfig"
        >保存</el-button>
      </template>
    </el-dialog>
    <el-dialog
      :visible="contractInvalidDialog.visible"
      @update:visible="handleContractInvalidDialogVisibleChange"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="contract-invalid-dialog"
      width="640px"
    >
      <template #title>
        <div class="contract-invalid-dialog__title">
          <i class="el-icon-close contract-invalid-dialog__icon"></i>
          <span>合同合规性校验未通过</span>
        </div>
      </template>
      <div class="contract-invalid-dialog__body">
        <div class="contract-invalid-dialog__summary">
          该合同无法通过有效性校验，请检查合同内容后重新上传。
        </div>
        <div class="contract-invalid-dialog__reason">
          <div class="contract-invalid-dialog__reason-title">失败原因：</div>
          <div class="contract-invalid-dialog__reason-text">
            {{ contractInvalidDialog.reason }}
          </div>
        </div>
      </div>
      <template #footer>
        <div class="contract-invalid-dialog__footer">
          <el-button
            type="primary"
            size="small"
            @click="handleInvalidDialogReupload"
          >重新上传 docx</el-button>
          <el-button size="small" @click="closeContractInvalidDialog">关闭</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import {
  contractTmpAdd,
  contractTmpEdit,
  contractTmpVariables,
  contractTmpPreview,
  contractTmpFixedContentApi,
  analysisContractAi,
  getAiAnalysisSummary,
} from '@/api/domain/carsService'
import { uploadFile } from '@/api/domain/vehicle'
import { contractTemplateModule } from '@/store/dict/withholdDict'
import TinymceVue from '@/components/TinymceVue/index.vue'
import LeasePlanForm from './LeasePlanForm.vue'
import {
  TinymcevueOptions,
  titleMap,
  GROUP_CONTRACT_TEMPLATE_CREATE,
  GROUP_CONTRACT_TEMPLATE_PREVIEW,
  exmUrl,
  storageKeyAdd,
  storageTitleKeyAdd,
  storageAiUuidKeyAdd,
  storageKeyEdit,
  storageTitleKeyEdit,
} from '../config.js'
import { throttle } from 'lodash'
import { getLocalStorage, setLocalStorage } from '@/utils/cache'

const PASTE_PARSE_MIN_LENGTH = 50

const DOCX_MIME = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
const DOCX_ACCEPT_TYPES = ['.docx', DOCX_MIME].join(',')

const CONTRACT_UPLOAD_GROUP = 'order'
const CONTRACT_UPLOAD_CODE = 'order_contract_attachment_file'
const AI_EMPTY_VALUE_RE = /^(null|undefined|未明确|无|暂无|不详|--|-|空)$/i

export default {
  name: 'contractTemplateEditor',
  components: {
    TinymceVue,
    LeasePlanForm,
  },
  props: {
    turnalFlag: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      contractTemplateModule,
      docxAcceptTypes: DOCX_ACCEPT_TYPES,
      exmUrl,
      currentStep: 1,
      checkItems: [], // 默认展开 系统字段
      oLoading: {
        add: false,
        edit: false,
        saveDraft: false,
        submitLeasePlan: false,
      },
      contractName: '',
      id: '',
      contractTemplateId: '',
      checkKey: null,
      contractContent: '',
      sendContractContent: '', // 最终接口发送的数据
      keywords: [],
      activeTab: '1',
      isReq: false, // 如果是委托代扣 是否是一次请求详情接口
      storageKeyAdd,
      storageTitleKeyAdd,
      storageAiUuidKeyAdd,
      storageKeyEdit,
      storageTitleKeyEdit,
      validResult: {
        valid: '',
        reason: '',
      },
      tinymceEditor: null,
      isProgrammaticContentChange: false,
      contractAiLoading: false,
      contentStats: {
        textLength: 0,
        placeholderCount: 0,
      },
      replacedFieldCollapse: [],
      replacedFields: [],
      placeholderUid: 1,
      isNormalizingPlaceholders: false,
      placeholderDialog: {
        visible: false,
        id: '',
        fieldName: '',
        groupName: '',
        fieldValue: '',
        sourceText: '',
        displayLabel: '',
      },
      contractInvalidDialog: {
        visible: false,
        reason: '',
      },
      contractImport: {
        status: 'idle',
        file: null,
        fileUrl: '',
        fileName: '',
        aiUuid: '',
        converting: false,
        parsing: false,
        warnings: [],
        parseMessage: '',
        parseResult: null,
        analysisData: null,
        summaryData: null,
        summaryLoading: false,
        summaryRequestedUuid: '',
        summaryWarningMessage: '',
      },
    }
  },
  watch: {
    activeTab(v) {
      if (Number(v) === 2) {
        this.sendContractContent = this.getSubmitContractContent()
      }
      this.contractContent = ''
      this.$nextTick(() => {
        this.setEditorContent('', { updateStorage: false })
      })
      if (Number(v) === 1) {
        this.$nextTick(() => {
          this.getEditor()?.setMode('design')
        })
        if (this.isReq) {
          this.contractContent = this.sendContractContent
          this.$nextTick(() => {
            this.setEditorContent(this.contractContent)
          })
        } else {
          this.contractTmpPreview()
        }
      } else {
        this.$nextTick(() => {
          this.getEditor()?.setMode('readonly')
        })
        this.contractTmpFixedContent()
      }
    },
    contractName(v) {
      setLocalStorage(this.isEdit ? storageTitleKeyEdit : storageTitleKeyAdd, v)
    },
  },
  computed: {
    tinymceOptions() {
      const _TinymcevueOptions = { ...TinymcevueOptions }
      const baseSetup = _TinymcevueOptions.setup
      const savedContent = getLocalStorage(this.isEdit ? this.storageKeyEdit : this.storageKeyAdd)
      const savedTitleName = getLocalStorage(
        this.isEdit ? this.storageTitleKeyEdit : this.storageTitleKeyAdd,
      )
      const savedAiUuid = this.isEdit ? '' : getLocalStorage(this.storageAiUuidKeyAdd)

      _TinymcevueOptions.setup = (editor) => {
        if (typeof baseSetup === 'function') {
          baseSetup(editor)
        }
        this.tinymceEditor = editor
        editor.on('click', (event) => {
          const placeholder = event.target?.closest?.('.contract-placeholder')
          if (!placeholder) return
          event.preventDefault()
          this.openPlaceholderDialog(placeholder)
        })
        editor.on('init', () => {
          this.tinymceEditor = editor
          this.updateContentStats()
        })
        const editorContentEvents = [
          'input',
          'change',
          'keyup',
          'NodeChange',
          'SetContent',
          'Undo',
          'Redo',
        ]
        editorContentEvents.forEach((eventName) => {
          editor.on(eventName, () => {
            setTimeout(() => {
              this.updateContentStats()
            }, 0)
          })
        })
      }
      const basePastePreprocess = _TinymcevueOptions.paste_preprocess
      _TinymcevueOptions.paste_preprocess = (plugin, args) => {
        if (typeof basePastePreprocess === 'function') {
          basePastePreprocess(plugin, args)
        }
        if (!this.shouldDeferPastedContractContent(args.content)) return

        const pastedHtml = this.normalizePastedContractHtml(args.content)
        const nextHtml = this.buildEditorHtmlWithPastedContent(pastedHtml)
        // eslint-disable-next-line no-param-reassign
        args.content = ''
        this.handlePastedContractContent(nextHtml)
      }

      _TinymcevueOptions.init_instance_callback = () => {
        this.updateContentStats()
        if (this.isEdit || this.isCopy) {
          this.id = parseInt(this.$route.query.id, 10)
          if (!savedContent && !savedTitleName) {
            this.contractTmpPreview()
          } else {
            this.getDraftContent(savedContent, savedTitleName, savedAiUuid)
          }
        }
      }
      const contentStyle = `
        body { font-size: 14px; line-height: 1.8; color: #333; }
        table { width: 100%; border-collapse: collapse; margin: 12px 0; }
        th, td { border: 1px solid #dcdfe6; padding: 6px 8px; vertical-align: top; }
        th { background: #f5f7fa; font-weight: 600; }
        .contract-placeholder {
          display: inline-block;
          min-width: 2em;
          padding: 0 4px;
          border: 1px solid #2d6cdf;
          border-radius: 3px;
          background: #eaf2ff;
          color: #1f5cc4;
          cursor: pointer;
          line-height: 1.6;
        }
        .contract-placeholder:hover {
          background: #dceaff;
        }
        .contract-placeholder.is-locating {
          animation: contract-placeholder-flash 1s ease-in-out 2;
        }
        @keyframes contract-placeholder-flash {
          0%, 100% { background: #eaf2ff; }
          50% { background: #9fc4ff; }
        }
      `
      _TinymcevueOptions.content_style = _TinymcevueOptions.content_style
        ? `${_TinymcevueOptions.content_style}\n${contentStyle}`
        : contentStyle
      return _TinymcevueOptions
    },
    isPermissionAdd() {
      const status = this.judgePermission(GROUP_CONTRACT_TEMPLATE_CREATE)
      return (this.isAdd || this.isCopy) && status
    },
    isAdd() {
      return this.turnalFlag === 'add'
    },
    isEdit() {
      return this.turnalFlag === 'edit'
    },
    needLeasePlanStep() {
      return !this.isEdit
    },
    isNextStepSaving() {
      return this.currentStep === 1 && this.needLeasePlanStep && this.oLoading.add
    },
    isCopy() {
      return this.turnalFlag === 'add' && this.$route.query.isCopy
    },
    pageTitle() {
      return titleMap.get(this.turnalFlag)
    },
    isShowRightOption() {
      if (this.moduleName) {
        if (this.activeTab === '2' && this.moduleName === contractTemplateModule.entrustWithholdContractTemplate) {
          return false
        }
      }
      return true
    },
    showStartAiParseButton() {
      return this.currentStep === 1 &&
        this.activeTab === '1' &&
        this.contractImport.status === 'pasteReady' &&
        !this.contractImport.parsing &&
        !this.contractImport.converting &&
        this.contentStats.textLength >= PASTE_PARSE_MIN_LENGTH
    },
  },
  async created() {
    const { moduleName } = this.$route.query
    this.moduleName = moduleName
    // 获取系统模版
    await this.selectVar()
  },
  methods: {
    enterRentalPlanStep() {
      this.$refs.leasePlanForm?.initDefaults?.()
      this.currentStep = 2
      this.$nextTick(() => {
        window.scrollTo(0, 0)
        this.loadAiSummaryAfterNextStep()
      })
    },
    goToContractStep() {
      this.currentStep = 1
      this.$nextTick(() => {
        window.scrollTo(0, 0)
      })
    },
    getEditor() {
      return this.tinymceEditor || window.tinymce?.activeEditor || window.tinyMCE?.activeEditor
    },
    getEditorContent(options = {}) {
      const editor = this.getEditor()
      if (!editor) return ''
      return editor.getContent(options)
    },
    getSubmitContractContent() {
      return this.cleanContractPlaceholderHtml(this.getEditorContent())
    },
    setEditorContent(content = '', options = {}) {
      const editor = this.getEditor()
      if (!editor) return
      this.isProgrammaticContentChange = true
      editor.setContent(content || '')
      this.contractContent = content || ''
      if (this.activeTab === '1') {
        this.sendContractContent = this.cleanContractPlaceholderHtml(content || '')
      }
      if (options.updateStorage !== false) {
        setLocalStorage(this.isEdit ? this.storageKeyEdit : this.storageKeyAdd, content || '')
      }
      setTimeout(() => {
        this.updateContentStats()
        this.isProgrammaticContentChange = false
      }, 0)
    },
    updateContentStats() {
      const editor = this.getEditor()
      if (!editor) {
        this.contentStats = {
          textLength: 0,
          placeholderCount: 0,
        }
        this.replacedFields = []
        return
      }
      this.normalizeEditorPlaceholders()
      const text = (editor.getContent({ format: 'text' }) || '').trim()
      this.contentStats = this.getContentStatsFromText(text)
      const html = editor.getContent()
      if (this.activeTab === '1') {
        this.contractContent = html
        this.sendContractContent = this.cleanContractPlaceholderHtml(html)
      }
      this.collectReplacedFields()
    },
    getContentStatsFromText(text = '') {
      const content = String(text || '').trim()
      return {
        textLength: content.length,
        placeholderCount: this.countContractPlaceholders(content),
      }
    },
    countContractPlaceholders(text = '') {
      const matches = String(text || '').match(/\$\{[^}]+\}/g)
      return matches ? matches.length : 0
    },
    normalizeEditorPlaceholders() {
      const editor = this.getEditor()
      const body = editor?.getBody?.()
      if (!body || this.isNormalizingPlaceholders) return

      this.isNormalizingPlaceholders = true
      let changed = false
      try {
        const textNodes = this.getPlainTextNodes(body)
        textNodes.forEach((textNode) => {
          const text = textNode.nodeValue || ''
          const matches = this.getPlaceholderTextMatches(text)
          if (!matches.length) return

          const fragment = document.createDocumentFragment()
          let cursor = 0
          matches.forEach((match) => {
            const start = match.index
            const end = start + match[0].length
            if (start > cursor) {
              fragment.appendChild(document.createTextNode(text.slice(cursor, start)))
            }
            const fieldName = String(match[1] || '').trim()
            fragment.appendChild(this.createPlaceholderElement({
              fieldName,
              groupName: this.getVariableGroupName(fieldName),
              displayLabel: match[0],
            }))
            cursor = end
          })
          if (cursor < text.length) {
            fragment.appendChild(document.createTextNode(text.slice(cursor)))
          }
          textNode.parentNode.replaceChild(fragment, textNode)
          changed = true
        })
        Array.from(body.querySelectorAll('.contract-placeholder')).forEach((node) => {
          if (!node.getAttribute('data-placeholder-id')) {
            this.ensurePlaceholderId(node)
            changed = true
          }
        })
        if (changed) {
          editor.nodeChanged()
        }
      } finally {
        this.isNormalizingPlaceholders = false
      }
    },
    getPlainTextNodes(root) {
      const walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            const parent = node.parentElement
            const parentTag = parent?.tagName
            if (
              !node.nodeValue ||
              parent?.closest?.('.contract-placeholder') ||
              ['SCRIPT', 'STYLE'].includes(parentTag)
            ) {
              return NodeFilter.FILTER_REJECT
            }
            return NodeFilter.FILTER_ACCEPT
          },
        },
      )
      const nodes = []
      while (walker.nextNode()) {
        nodes.push(walker.currentNode)
      }
      return nodes
    },
    getPlaceholderTextMatches(text = '') {
      const pattern = /\$\{([^}]+)\}/g
      const matches = []
      let match = pattern.exec(text)
      while (match) {
        matches.push(match)
        if (pattern.lastIndex <= match.index) {
          pattern.lastIndex = match.index + 1
        }
        match = pattern.exec(text)
      }
      return matches
    },
    createPlaceholderElement({
      fieldName,
      groupName = '',
      fieldValue = '',
      sourceText = '',
      displayLabel = '',
    }) {
      const span = document.createElement('span')
      span.className = 'contract-placeholder'
      span.setAttribute('data-placeholder-id', this.createPlaceholderId())
      span.setAttribute('data-field', fieldName || '')
      span.setAttribute('data-group', groupName || this.getVariableGroupName(fieldName))
      span.setAttribute('data-value', fieldValue || '')
      span.setAttribute('data-source-text', sourceText || '')
      span.textContent = displayLabel || this.buildPlaceholderLabel(fieldName)
      return span
    },
    createPlaceholderHtml(options = {}) {
      const el = this.createPlaceholderElement(options)
      const wrapper = document.createElement('div')
      wrapper.appendChild(el)
      return wrapper.innerHTML
    },
    createPlaceholderId() {
      const id = `contract-placeholder-${Date.now()}-${this.placeholderUid}`
      this.placeholderUid += 1
      return id
    },
    ensurePlaceholderId(node) {
      const existed = node.getAttribute('data-placeholder-id')
      if (existed) return existed
      const id = this.createPlaceholderId()
      node.setAttribute('data-placeholder-id', id)
      return id
    },
    buildPlaceholderLabel(fieldName) {
      return `\${${fieldName || ''}}`
    },
    cleanContractPlaceholderHtml(html = '') {
      const container = document.createElement('div')
      container.innerHTML = html || ''
      Array.from(container.querySelectorAll('.contract-placeholder')).forEach((node) => {
        const fieldName = node.getAttribute('data-field') || ''
        const text = node.textContent || this.buildPlaceholderLabel(fieldName)
        node.parentNode.replaceChild(document.createTextNode(text), node)
      })
      Array.from(container.querySelectorAll('.placeholder-source-highlight')).forEach((node) => {
        node.parentNode.replaceChild(document.createTextNode(node.textContent || ''), node)
      })
      return container.innerHTML
    },
    collectReplacedFields() {
      const editor = this.getEditor()
      const body = editor?.getBody?.()
      if (!body) {
        this.replacedFields = []
        return
      }
      this.replacedFields = Array.from(body.querySelectorAll('.contract-placeholder'))
        .map((node, index) => {
          const fieldName = node.getAttribute('data-field') ||
            this.extractPlaceholderFieldName(node.textContent)
          const groupName = node.getAttribute('data-group') ||
            this.getVariableGroupName(fieldName)
          if (fieldName && !node.getAttribute('data-field')) {
            node.setAttribute('data-field', fieldName)
          }
          if (groupName && !node.getAttribute('data-group')) {
            node.setAttribute('data-group', groupName)
          }
          return {
            id: this.ensurePlaceholderId(node),
            fieldName,
            groupName,
            fieldValue: node.getAttribute('data-value') || '',
            sourceText: node.getAttribute('data-source-text') || '',
            displayLabel: node.textContent || this.buildPlaceholderLabel(fieldName),
            index,
          }
        })
    },
    extractPlaceholderFieldName(text = '') {
      const match = String(text || '').match(/\$\{([^}]+)\}/)
      return match ? match[1].trim() : String(text || '').trim()
    },
    getShortText(text = '', max = 12) {
      const value = String(text || '').trim()
      if (!value) return '--'
      return value.length > max ? `${value.slice(0, max)}...` : value
    },
    getVariableGroupName(fieldName) {
      const meta = this.findVariableMeta(fieldName)
      return meta.groupName || ''
    },
    findVariableMeta(fieldName) {
      const normalizedFieldName = this.normalizeContractFieldName(fieldName)
      let result = {}
      const groups = this.keywords || []
      groups.some((group) => {
        const groupName = group.title || group.name || group.label || ''
        return (group.children || []).some((item) => {
          const variableName = item.name || item.key || item.label || item.fieldName || ''
          const matched = this.normalizeContractFieldName(variableName) === normalizedFieldName
          if (matched) {
            result = {
              ...item,
              variableName,
              groupName,
            }
          }
          return matched
        })
      })
      return result
    },
    openPlaceholderDialog(node) {
      const fieldName = node.getAttribute('data-field') ||
        this.extractPlaceholderFieldName(node.textContent)
      const groupName = node.getAttribute('data-group') || this.getVariableGroupName(fieldName)
      const id = this.ensurePlaceholderId(node)
      this.placeholderDialog = {
        visible: true,
        id,
        fieldName,
        groupName,
        fieldValue: node.getAttribute('data-value') || '',
        sourceText: node.getAttribute('data-source-text') || '',
        displayLabel: node.textContent || this.buildPlaceholderLabel(fieldName),
      }
    },
    closePlaceholderDialog() {
      this.placeholderDialog.visible = false
    },
    handlePlaceholderDialogVisibleChange(visible) {
      this.placeholderDialog.visible = visible
    },
    savePlaceholderConfig() {
      const node = this.getPlaceholderNodeById(this.placeholderDialog.id)
      if (!node) {
        this.closePlaceholderDialog()
        return
      }
      const { fieldName } = this.placeholderDialog
      node.setAttribute('data-field', fieldName)
      node.setAttribute('data-group', this.placeholderDialog.groupName || '')
      node.setAttribute('data-value', this.placeholderDialog.fieldValue || '')
      node.setAttribute('data-source-text', this.placeholderDialog.sourceText || '')
      const displayLabel = this.placeholderDialog.displayLabel ||
        this.buildPlaceholderLabel(fieldName)
      node.textContent = displayLabel
      this.closePlaceholderDialog()
      this.updateContentStats()
    },
    restorePlaceholder() {
      const node = this.getPlaceholderNodeById(this.placeholderDialog.id)
      if (!node) {
        this.closePlaceholderDialog()
        return
      }
      const sourceText = this.placeholderDialog.sourceText ||
        this.placeholderDialog.displayLabel ||
        this.buildPlaceholderLabel(this.placeholderDialog.fieldName)
      node.parentNode.replaceChild(document.createTextNode(sourceText), node)
      this.closePlaceholderDialog()
      this.updateContentStats()
    },
    getPlaceholderNodeById(id) {
      const editor = this.getEditor()
      const body = editor?.getBody?.()
      if (!body || !id) return null
      const selector = `.contract-placeholder[data-placeholder-id="${this.escapeCssSelector(id)}"]`
      return body.querySelector(selector)
    },
    locateReplacedField(item) {
      const editor = this.getEditor()
      const body = editor?.getBody?.()
      if (!body) return
      const selector = item.id
        ? `.contract-placeholder[data-placeholder-id="${this.escapeCssSelector(item.id)}"]`
        : `.contract-placeholder[data-field="${this.escapeCssSelector(item.fieldName)}"]`
      const node = body.querySelector(selector)
      if (!node) {
        this.$message.warning('未找到字段位置')
        return
      }
      node.scrollIntoView({ behavior: 'smooth', block: 'center' })
      node.classList.remove('is-locating')
      node.getBoundingClientRect()
      node.classList.add('is-locating')
      editor.selection?.select?.(node)
      setTimeout(() => {
        node.classList.remove('is-locating')
      }, 2000)
    },
    escapeCssSelector(value) {
      if (window.CSS && typeof window.CSS.escape === 'function') {
        return window.CSS.escape(value)
      }
      return String(value).replace(/([!"#$%&'()*+,\-./:;<=>?@[\\\]^`{|}~])/g, '\\$1')
    },
    shouldDeferPastedContractContent(html) {
      if (this.isProgrammaticContentChange) {
        return false
      }
      if (
        this.activeTab !== '1' ||
        this.contractImport.converting ||
        this.contractImport.parsing
      ) {
        return false
      }
      const textLength = this.extractTextFromHtml(this.normalizePastedContractHtml(html)).length
      return textLength >= PASTE_PARSE_MIN_LENGTH
    },
    normalizePastedContractHtml(html) {
      const content = String(html || '').trim()
      if (!content) return ''
      return content
    },
    buildEditorHtmlWithPastedContent(pastedHtml) {
      const editor = this.getEditor()
      if (!editor) return pastedHtml

      const currentHtml = this.getEditorContent()
      if (!currentHtml) return pastedHtml

      try {
        const body = editor.getBody()
        const range = editor.selection?.getRng?.()
        if (
          !body ||
          !range ||
          !body.contains(range.startContainer) ||
          !body.contains(range.endContainer)
        ) {
          return `${currentHtml}${pastedHtml}`
        }

        const bodyClone = body.cloneNode(true)
        const startPath = this.getNodePath(body, range.startContainer)
        const endPath = this.getNodePath(body, range.endContainer)
        const cloneStartNode = this.getNodeByPath(bodyClone, startPath)
        const cloneEndNode = this.getNodeByPath(bodyClone, endPath)
        if (!cloneStartNode || !cloneEndNode) {
          return `${currentHtml}${pastedHtml}`
        }

        const cloneRange = document.createRange()
        cloneRange.setStart(
          cloneStartNode,
          Math.min(range.startOffset, this.getNodeMaxOffset(cloneStartNode)),
        )
        cloneRange.setEnd(
          cloneEndNode,
          Math.min(range.endOffset, this.getNodeMaxOffset(cloneEndNode)),
        )
        const fragmentRange = document.createRange()
        fragmentRange.selectNodeContents(bodyClone)
        const fragment = fragmentRange.createContextualFragment(pastedHtml)
        cloneRange.deleteContents()
        cloneRange.insertNode(fragment)
        return bodyClone.innerHTML
      } catch (error) {
        return `${currentHtml}${pastedHtml}`
      }
    },
    getNodePath(root, node) {
      const path = []
      let current = node
      while (current && current !== root) {
        const parent = current.parentNode
        if (!parent) return []
        path.unshift(Array.prototype.indexOf.call(parent.childNodes, current))
        current = parent
      }
      return path
    },
    getNodeByPath(root, path = []) {
      return path.reduce((node, index) => node?.childNodes?.[index] || null, root)
    },
    getNodeMaxOffset(node) {
      if (!node) return 0
      if (node.nodeType === Node.TEXT_NODE) return node.nodeValue.length
      return node.childNodes.length
    },
    handlePastedContractContent(html) {
      if (!this.markPasteMode()) return
      const text = this.extractTextFromHtml(html)
      this.contentStats = this.getContentStatsFromText(text)
      this.setEditorContent(html)
    },
    markPasteMode() {
      if (
        this.contractImport.converting ||
        this.contractImport.parsing
      ) {
        return false
      }
      this.contractImport = {
        ...this.contractImport,
        status: 'pasteReady',
        file: null,
        fileUrl: '',
        fileName: '',
        aiUuid: '',
        warnings: [],
        parseMessage: '',
        parseResult: null,
        analysisData: null,
        summaryData: null,
        summaryLoading: false,
        summaryRequestedUuid: '',
        summaryWarningMessage: '',
      }
      this.saveDraftAiUuid('')
      return true
    },
    async handleStartAiParseFromPaste() {
      if (this.contractImport.parsing) return
      await this.startAiParsingFromHtml()
    },
    triggerDocxUpload() {
      const input = Array.isArray(this.$refs.docxInput)
        ? this.$refs.docxInput[0]
        : this.$refs.docxInput
      if (!input) return
      input.value = ''
      input.click()
    },
    async handleDocxSelected(event) {
      const input = event.target
      const file = input.files && input.files[0]
      if (!file) return

      if (!this.isDocxFile(file)) {
        this.$message.error('仅支持上传 .docx 合同文件')
        input.value = ''
        return
      }

      this.contractAiLoading = true
      this.contractImport = {
        status: 'converting',
        file,
        fileUrl: '',
        fileName: file.name,
        aiUuid: '',
        converting: true,
        parsing: false,
        warnings: [],
        parseMessage: '正在转换合同文件，请稍候...',
        parseResult: null,
        analysisData: null,
        summaryData: null,
        summaryLoading: false,
        summaryRequestedUuid: '',
        summaryWarningMessage: '',
      }

      try {
        const { html, warnings } = await this.convertDocxInBrowser(file)
        this.contractImport.converting = false
        this.contractImport.status = 'converted'
        this.contractImport.warnings = warnings
        this.contractImport.parseMessage = '转换完成，已自动启动 AI 智能解析。'
        if (!this.contractName) {
          this.contractName = this.getContractNameFromFileName(file.name)
        }
        await this.startAiParsingFromDocx({
          auto: true,
          sourceHtml: html,
        })
      } catch (error) {
        this.contractImport = {
          ...this.contractImport,
          file: null,
          converting: false,
          status: 'convertFailed',
          parseMessage: `转换失败，请检查合同文件。${this.getErrorMessage(error)}`,
        }
        this.contractAiLoading = false
        this.$message.error('转换失败，请检查合同文件')
      } finally {
        input.value = ''
      }
    },
    isDocxFile(file) {
      const name = file.name || ''
      return name.toLowerCase().endsWith('.docx') ||
        file.type === DOCX_MIME
    },
    async convertDocxInBrowser(file) {
      const { mammoth } = window
      if (!mammoth || typeof mammoth.convertToHtml !== 'function') {
        throw new Error('Word 转换插件未加载')
      }
      const arrayBuffer = await this.readFileAsArrayBuffer(file)
      const result = await mammoth.convertToHtml({ arrayBuffer })
      const html = this.normalizeConvertedHtml(result.value || '')
      const warnings = (result.messages || [])
        .map((item) => item.message || String(item))
        .filter(Boolean)

      if (!this.extractTextFromHtml(html)) {
        throw new Error('未识别到可预览的合同内容')
      }

      return {
        html,
        warnings,
      }
    },
    readFileAsArrayBuffer(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = () => reject(reader.error || new Error('文件读取失败'))
        reader.readAsArrayBuffer(file)
      })
    },
    normalizeConvertedHtml(html) {
      return html
        .replace(/<table/gi, '<table style="border-collapse:collapse;width:100%;" border="1"')
        .replace(/<img/gi, '<img style="max-width:100%;"')
    },
    extractTextFromHtml(html) {
      const div = document.createElement('div')
      div.innerHTML = html || ''
      return (div.textContent || '').trim()
    },
    async startAiParsingFromDocx({ auto = false, sourceHtml = '' } = {}) {
      if (this.contractImport.parsing) return false
      if (!this.contractImport.file) {
        this.$message.warning('请先上传 .docx 合同文件')
        return false
      }

      this.contractAiLoading = true
      this.contractImport.parsing = true
      this.contractImport.status = 'parsing'
      this.contractImport.parseMessage = '正在上传合同文件并启动 AI 智能解析，请稍候...'

      try {
        const fileUrl =
          this.contractImport.fileUrl ||
          await this.uploadContractFile(this.contractImport.file)
        this.contractImport.fileUrl = fileUrl
        await this.runContractAiAnalysis({
          fileUrl,
          fileText: null,
          sourceHtml,
          successMessage: 'AI 智能解析已完成',
          warningMessage: 'AI 智能解析已完成，摘要信息暂未获取成功',
        })
        return true
      } catch (error) {
        this.contractImport.status = 'parseFailed'
        this.contractImport.parseMessage =
          `AI 解析暂未完成，合同内容未写入编辑器。${this.getErrorMessage(error)}`
        if (!auto) {
          this.$message.error('AI 智能解析失败，请稍后重试')
        } else {
          this.$message.warning('AI 智能解析失败，合同内容未写入编辑器')
        }
        return false
      } finally {
        this.contractImport.parsing = false
        this.contractAiLoading = false
      }
    },
    async uploadContractFile(file) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('group', CONTRACT_UPLOAD_GROUP)
      formData.append('code', CONTRACT_UPLOAD_CODE)
      const { code, data, msg } = await uploadFile(formData)
      if (code !== 1 || !data) {
        throw new Error(msg || '合同文件上传失败')
      }
      return data
    },
    async startAiParsingFromHtml(sourceHtml = '') {
      const html = sourceHtml || this.getEditorContent()
      const text = this.extractTextFromHtml(html)
      const textLength = text.length
      this.contentStats = this.getContentStatsFromText(text)
      if (textLength < PASTE_PARSE_MIN_LENGTH) {
        this.$message.error(`粘贴内容过短，至少 ${PASTE_PARSE_MIN_LENGTH} 字符后才能解析`)
        return false
      }
      if (this.contractImport.parsing) return false

      this.contractAiLoading = true
      this.contractImport.parsing = true
      this.contractImport.status = 'parsing'
      this.contractImport.parseMessage = '正在提交粘贴合同内容并启动 AI 智能解析...'

      try {
        await this.runContractAiAnalysis({
          fileUrl: null,
          fileText: this.buildAiFileTextFromHtml(html),
          sourceHtml: html,
          successMessage: '粘贴内容已完成 AI 智能解析',
          warningMessage: '粘贴内容已完成 AI 智能解析，摘要信息暂未获取成功',
        })
        return true
      } catch (error) {
        this.contractImport.status = 'pasteReady'
        this.contractImport.parseMessage =
          `粘贴内容解析失败，请稍后重试。${this.getErrorMessage(error)}`
        this.$message.error('粘贴内容解析失败，请稍后重试')
        return false
      } finally {
        this.contractImport.parsing = false
        this.contractAiLoading = false
      }
    },
    buildAiFileTextFromHtml(html) {
      return html || this.extractTextFromHtml(html) || ''
    },
    async runContractAiAnalysis({
      fileUrl,
      fileText,
      sourceHtml = '',
      successMessage,
      warningMessage,
    }) {
      const { code, data, msg } = await analysisContractAi({
        fileUrl: fileUrl || null,
        fileText: fileText || null,
      })
      if (code !== 1 || !data) {
        throw new Error(msg || '合同 AI 识别失败')
      }

      if (sourceHtml) {
        this.setEditorContent(sourceHtml)
      }

      if (data.uuid) {
        this.contractImport.aiUuid = data.uuid
        this.saveDraftAiUuid(data.uuid)
      }

      this.applyContractAiResult(data)
      this.contractImport.parseResult = {
        analysis: data,
        summary: null,
        summaryError: null,
      }
      this.contractImport.analysisData = data
      this.contractImport.summaryData = null
      this.contractImport.summaryWarningMessage = warningMessage
      this.contractImport.status = 'parsed'
      this.contractImport.parseMessage = successMessage
      if (data.valid === false) {
        this.showContractInvalidDialog(data.invalidReason)
      } else {
        this.$message.success(successMessage)
      }
    },
    showContractInvalidDialog(reason) {
      this.contractInvalidDialog = {
        visible: true,
        reason: reason || '合同检测失败',
      }
    },
    closeContractInvalidDialog() {
      this.contractInvalidDialog.visible = false
    },
    handleContractInvalidDialogVisibleChange(visible) {
      this.contractInvalidDialog.visible = visible
    },
    handleInvalidDialogReupload() {
      this.closeContractInvalidDialog()
      this.$nextTick(() => {
        this.triggerDocxUpload()
      })
    },
    async fetchAiAnalysisSummary(uuid, analysisData = {}, warningMessage = '') {
      let summaryData = null
      let summaryError = null
      this.contractImport.summaryLoading = true
      try {
        const summaryRes = await getAiAnalysisSummary({ uuid })
        if (summaryRes.code === 1) {
          summaryData = this.parseMaybeJson(summaryRes.data) || null
        } else {
          summaryError = new Error(summaryRes.msg || '摘要信息获取失败')
        }
      } catch (error) {
        summaryError = error
      }

      if (this.contractImport.aiUuid !== uuid) {
        this.contractImport.summaryLoading = false
        return
      }

      this.contractImport.parseResult = {
        ...(this.contractImport.parseResult || {}),
        analysis: analysisData,
        summary: summaryData,
        summaryError,
      }
      this.contractImport.summaryData = summaryData

      if (summaryData) {
        this.$refs.leasePlanForm?.applyAiResult?.(analysisData, summaryData)
      }
      if (summaryError) {
        this.contractImport.status = 'parseWarning'
        this.contractImport.parseMessage = warningMessage
      }
      this.contractImport.summaryLoading = false
    },
    loadAiSummaryAfterNextStep() {
      const uuid = this.contractImport.aiUuid
      const { analysisData } = this.contractImport
      if (!uuid || !analysisData) return
      if (
        this.contractImport.summaryLoading ||
        this.contractImport.summaryData ||
        this.contractImport.summaryRequestedUuid === uuid
      ) {
        return
      }

      this.contractImport.summaryRequestedUuid = uuid
      this.fetchAiAnalysisSummary(
        uuid,
        analysisData,
        this.contractImport.summaryWarningMessage || '摘要信息暂未获取成功',
      )
    },
    applyContractAiResult(analysisData = {}, summaryData = null) {
      if (typeof analysisData.valid === 'boolean') {
        this.validResult = {
          valid: analysisData.valid ? 1 : 0,
          reason: analysisData.invalidReason || '',
        }
      }
      this.applyAiFieldMappingsToEditor(analysisData)
      this.$refs.leasePlanForm?.applyAiResult?.(analysisData, summaryData)
      if (summaryData) {
        this.contractImport.summaryData = summaryData
      }
    },
    applyAiFieldMappingsToEditor(analysisData = {}) {
      const fieldExtract = this.parseMaybeJson(analysisData.fieldExtract) || {}
      const replacements = this.buildAiPlaceholderReplacements(fieldExtract, analysisData)
      if (!replacements.length) return

      const html = this.getEditorContent()
      const replaceResult = this.replaceHtmlTextWithPlaceholders(html, replacements)
      if (!replaceResult.count || replaceResult.html === html) return

      this.setEditorContent(replaceResult.html)
      this.contractImport.placeholderReplaceCount = replaceResult.count
      this.contractImport.placeholderFields = replaceResult.fields
    },
    buildAiPlaceholderReplacements(fieldExtract = {}, analysisData = {}) {
      const fieldMappings = this.getAiFieldMappings(fieldExtract, analysisData)
      if (!fieldMappings || typeof fieldMappings !== 'object') return []

      const variableLookup = this.getContractVariableLookup()
      const replacements = []
      const existedReplacementKeys = new Set()
      Object.entries(fieldMappings).forEach(([groupName, fields]) => {
        if (!fields || typeof fields !== 'object') return

        Object.entries(fields).forEach(([fieldName, value]) => {
          const variableName = this.findContractVariableName(groupName, fieldName, variableLookup)
          if (!variableName) return

          const placeholder = `\${${variableName}}`
          const variableMeta = this.findVariableMeta(variableName)
          const fieldValue = this.getReplacementDisplayValue(value)
          const sourceContext = this.getAiEntrySourceText(value)
          const labelCandidates = this.getReplacementLabelCandidates({
            groupName,
            fieldName,
            variableName,
            variableMeta,
          })
          this.getAiReplacementValues(value).forEach((sourceValue) => {
            if (!sourceValue || sourceValue === placeholder) return

            const sourceKey = this.normalizeReplacementSourceKey(sourceValue)
            const replacementKey = [
              sourceKey,
              placeholder,
              this.normalizeReplacementSourceKey(sourceContext),
            ].join('|')
            if (existedReplacementKeys.has(replacementKey)) return
            existedReplacementKeys.add(replacementKey)

            replacements.push({
              sourceValue,
              sourceKey,
              sourceContext,
              placeholder,
              fieldName: variableName,
              groupName: variableMeta.groupName || groupName,
              fieldValue,
              fieldLabelCandidates: labelCandidates.fieldLabels,
              groupLabelCandidates: labelCandidates.groupLabels,
              isNumeric: this.isNumericLikeValue(sourceValue),
            })
          })
        })
      })

      const sourcePlaceholderMap = new Map()
      replacements.forEach((item) => {
        if (!sourcePlaceholderMap.has(item.sourceKey)) {
          sourcePlaceholderMap.set(item.sourceKey, new Set())
        }
        sourcePlaceholderMap.get(item.sourceKey).add(item.placeholder)
      })
      return replacements
        .map((item) => ({
          ...item,
          isAmbiguousSource: (sourcePlaceholderMap.get(item.sourceKey)?.size || 0) > 1,
        }))
        .sort((prev, next) => next.sourceValue.length - prev.sourceValue.length)
    },
    getAiFieldMappings(fieldExtract = {}, analysisData = {}) {
      return fieldExtract.fieldMappings ||
        fieldExtract.field_mappings ||
        analysisData.fieldMappings ||
        analysisData.field_mappings ||
        {}
    },
    getContractVariableLookup() {
      const byName = new Map()
      const byGroupName = new Map()
      const groups = this.keywords || []
      groups.forEach((group) => {
        const groupName = group.title || group.name || group.label || ''
        const children = group.children || []
        children.forEach((item) => {
          const variableName = item.name || item.key || item.label || item.fieldName || ''
          if (!variableName) return

          const candidates = [
            item.name,
            item.key,
            item.label,
            item.fieldName,
            item.title,
          ].filter(Boolean)
          candidates.forEach((candidate) => {
            const normalizedCandidate = this.normalizeContractFieldName(candidate)
            if (!normalizedCandidate) return
            byName.set(normalizedCandidate, variableName)
            byGroupName.set(
              `${this.normalizeContractFieldName(groupName)}.${normalizedCandidate}`,
              variableName,
            )
          })
        })
      })
      return {
        byName,
        byGroupName,
      }
    },
    findContractVariableName(groupName, fieldName, variableLookup) {
      const groupKey = `${this.normalizeContractFieldName(groupName)}.${this.normalizeContractFieldName(fieldName)}`
      if (variableLookup.byGroupName.has(groupKey)) {
        return variableLookup.byGroupName.get(groupKey)
      }

      const nameKey = this.normalizeContractFieldName(fieldName)
      if (variableLookup.byName.has(nameKey)) {
        return variableLookup.byName.get(nameKey)
      }
      return ''
    },
    normalizeContractFieldName(value) {
      return String(value || '')
        .replace(/[（）()[\]【】{}<>《》\s:_：/\\-]/g, '')
        .toLowerCase()
    },
    getAiReplacementValues(value) {
      const normalizedValue = this.normalizeAiValue(value)
      if (normalizedValue === undefined || normalizedValue === null) return []
      if (Array.isArray(normalizedValue)) return []
      const text = this.cleanAiReplacementText(normalizedValue)
      if (!this.isSafeReplacementSource(text)) return []

      const values = [text]
      this.getNumberReplacementVariants(text).forEach((item) => values.push(item))
      this.getDateReplacementVariants(text).forEach((item) => values.push(item))

      return Array.from(new Set(values))
        .filter((item) => this.isSafeReplacementSource(item))
    },
    getReplacementDisplayValue(value) {
      const normalizedValue = this.normalizeAiValue(value)
      if (normalizedValue === undefined || normalizedValue === null) return ''
      if (typeof normalizedValue === 'object') {
        return JSON.stringify(normalizedValue)
      }
      return this.cleanAiReplacementText(normalizedValue)
    },
    getAiEntrySourceText(value) {
      if (!value || typeof value !== 'object' || Array.isArray(value)) return ''
      const candidates = [
        value.source_text,
        value.sourceText,
        value.source,
        value.context,
        value.sentence,
        value.raw && value.raw.source_text,
        value.raw && value.raw.sourceText,
        value.raw && value.raw.source,
        value.raw && value.raw.context,
        value.raw && value.raw.sentence,
      ]
      for (const candidate of candidates) {
        const text = this.cleanAiReplacementText(candidate)
        if (text) return text
      }
      return ''
    },
    cleanAiReplacementText(value) {
      if (value === undefined || value === null) return ''
      if (Array.isArray(value)) {
        return value.map((item) => this.cleanAiReplacementText(item)).filter(Boolean).join('、')
      }
      if (value && typeof value === 'object') return ''
      const text = String(value).trim()
      if (!text || AI_EMPTY_VALUE_RE.test(text)) return ''
      return text
    },
    getReplacementLabelCandidates({
      groupName,
      fieldName,
      variableName,
      variableMeta = {},
    }) {
      const fieldLabels = this.expandReplacementLabelCandidates([
        fieldName,
        variableMeta.label,
        variableMeta.title,
        variableMeta.fieldName,
        variableMeta.name,
        variableMeta.key,
        variableName,
        ...this.getReplacementFieldAliases(fieldName),
        ...this.getReplacementFieldAliases(variableName),
      ])
      const groupLabels = this.expandReplacementLabelCandidates([
        groupName,
        variableMeta.groupName,
        ...this.getReplacementGroupAliases(groupName || variableMeta.groupName),
      ])
      return {
        fieldLabels,
        groupLabels,
      }
    },
    getReplacementGroupAliases(groupName = '') {
      const text = String(groupName || '')
      const aliases = []
      if (/出租|甲方/.test(text)) aliases.push('出租方', '甲方')
      if (/客户|承租|乙方/.test(text)) aliases.push('客户', '承租方', '乙方')
      if (/车辆/.test(text)) aliases.push('车辆', '车牌', '车辆信息')
      if (/合同/.test(text)) aliases.push('合同', '合同信息')
      if (/收款|款项|费用/.test(text)) aliases.push('收款项', '款项', '费用')
      return aliases
    },
    getReplacementFieldAliases(fieldName = '') {
      const text = String(fieldName || '')
      const aliases = []
      if (/每期租金|租金/.test(text)) aliases.push('每期租金', '租金')
      if (/日租金/.test(text)) aliases.push('日租金')
      if (/押金|保证金/.test(text)) aliases.push('押金', '保证金')
      if (/管理费/.test(text)) aliases.push('管理费')
      if (/服务费|技术服务费/.test(text)) aliases.push('服务费', '技术服务费')
      if (/首付款/.test(text)) aliases.push('首付款')
      if (/尾款/.test(text)) aliases.push('尾款')
      if (/全款/.test(text)) aliases.push('全款')
      return aliases
    },
    expandReplacementLabelCandidates(values = []) {
      const candidates = []
      values.filter(Boolean).forEach((value) => {
        const text = String(value).replace(/[【】]/g, '').trim()
        if (!text) return
        candidates.push(text)

        const withoutInfo = text.replace(/信息$/, '')
        if (withoutInfo && withoutInfo !== text) candidates.push(withoutInfo)

        const withoutRole = text.replace(/^(客户|承租方|承租人|出租方|出租人|甲方|乙方|车辆|合同)/, '')
        if (withoutRole && withoutRole !== text) candidates.push(withoutRole)

        text.split(/[（）()[\]、,，:：/\\\-\s]+/)
          .filter((item) => item.length >= 2)
          .forEach((item) => candidates.push(item))
      })

      return Array.from(new Set(candidates))
        .filter((item) => this.normalizeReplacementContextText(item).length >= 2)
    },
    getNumberReplacementVariants(value) {
      const text = String(value || '').replace(/,/g, '').trim()
      if (!/^-?\d+(\.\d+)?$/.test(text)) return []

      const numberValue = Number(text)
      if (!Number.isFinite(numberValue)) return []

      const variants = [
        text,
        String(numberValue),
        numberValue.toFixed(2),
      ]
      if (/\.0+$/.test(text)) {
        variants.push(text.replace(/\.0+$/, ''))
      }
      variants.push(numberValue.toLocaleString('en-US'))
      variants.push(numberValue.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }))
      return variants
    },
    getDateReplacementVariants(value) {
      const text = String(value || '').trim()
      if (!/\d{4}[-/]\d{1,2}[-/]\d{1,2}/.test(text)) return []
      return [
        text.replace(/\//g, '-'),
        text.replace(/-/g, '/'),
      ]
    },
    isSafeReplacementSource(value) {
      const text = this.cleanAiReplacementText(value)
      if (!text || /^\$\{.+\}$/.test(text)) return false
      if (/^[\d.]+$/.test(text)) return text.replace(/\D/g, '').length >= 2
      return text.length >= 2
    },
    normalizeReplacementSourceKey(value) {
      return this.normalizeReplacementContextText(value)
    },
    isNumericLikeValue(value) {
      return /^-?[\d,]+(\.\d+)?$/.test(String(value || '').trim())
    },
    replaceHtmlTextWithPlaceholders(html, replacements = []) {
      const container = document.createElement('div')
      container.innerHTML = html || ''
      const textNodes = this.getPlainTextNodes(container)
      const sourceOccurrenceMap = this.getReplacementSourceOccurrenceMap(textNodes, replacements)
      const knownFieldLabels = this.getKnownReplacementFieldLabels()

      let replaceCount = 0
      const replacedFields = new Set()
      for (const textNode of textNodes) {
        const text = textNode.nodeValue || ''
        const candidates = []
        for (const item of replacements) {
          const ranges = this.findReplacementRanges(text, item.sourceValue, item.isNumeric)
          for (const range of ranges) {
            if (
              this.hasConflictingReplacementFieldLabel(
                text,
                range,
                item,
                knownFieldLabels,
              )
            ) {
              continue
            }
            const score = this.getReplacementRangeScore(textNode, text, range, item)
            const sourceOccurrenceCount = sourceOccurrenceMap.get(item.sourceKey) || 0
            if (!this.shouldUseReplacementRange(item, score, sourceOccurrenceCount)) continue

            candidates.push({
              ...range,
              item,
              score,
            })
          }
        }
        const matches = this.selectReplacementMatches(candidates)
        if (!matches.length) continue

        const fragment = document.createDocumentFragment()
        let cursor = 0
        for (const match of matches) {
          if (match.start < cursor) continue
          if (match.start > cursor) {
            fragment.appendChild(document.createTextNode(text.slice(cursor, match.start)))
          }
          fragment.appendChild(this.createPlaceholderElement({
            fieldName: match.item.fieldName,
            groupName: match.item.groupName,
            fieldValue: match.item.fieldValue,
            sourceText: text.slice(match.start, match.end),
            displayLabel: match.item.placeholder,
          }))
          cursor = match.end
          replaceCount += 1
          replacedFields.add(match.item.fieldName)
        }
        if (cursor < text.length) {
          fragment.appendChild(document.createTextNode(text.slice(cursor)))
        }
        textNode.parentNode.replaceChild(fragment, textNode)
      }

      return {
        html: container.innerHTML,
        count: replaceCount,
        fields: Array.from(replacedFields),
      }
    },
    getReplacementSourceOccurrenceMap(textNodes, replacements = []) {
      const sourceItems = new Map()
      replacements.forEach((item) => {
        if (!sourceItems.has(item.sourceKey)) {
          sourceItems.set(item.sourceKey, item)
        }
      })

      const sourceOccurrenceMap = new Map()
      sourceItems.forEach((item, sourceKey) => {
        let count = 0
        textNodes.forEach((textNode) => {
          count += this.findReplacementRanges(
            textNode.nodeValue || '',
            item.sourceValue,
            item.isNumeric,
          ).length
        })
        sourceOccurrenceMap.set(sourceKey, count)
      })
      return sourceOccurrenceMap
    },
    selectReplacementMatches(candidates = []) {
      const selected = []
      candidates
        .sort((prev, next) => {
          if (next.score !== prev.score) return next.score - prev.score
          const prevLength = prev.end - prev.start
          const nextLength = next.end - next.start
          if (nextLength !== prevLength) return nextLength - prevLength
          return prev.start - next.start
        })
        .forEach((candidate) => {
          const hasOverlap = selected.some((match) => this.isRangeOverlap(match, candidate))
          if (!hasOverlap) {
            selected.push(candidate)
          }
        })

      return selected.sort((prev, next) => prev.start - next.start)
    },
    shouldUseReplacementRange(item, score, sourceOccurrenceCount) {
      if (score > 0) return true
      if (item.isAmbiguousSource) return false
      if (this.isWeakReplacementSource(item.sourceValue)) return false
      if (sourceOccurrenceCount <= 1) return true
      return this.isStrongReplacementSource(item.sourceValue)
    },
    getKnownReplacementFieldLabels() {
      const labels = [
        '每期租金',
        '租金',
        '日租金',
        '押金',
        '保证金',
        '管理费',
        '服务费',
        '技术服务费',
        '首付款',
        '尾款',
        '全款',
      ]
      const groups = this.keywords || []
      groups.forEach((group) => {
        const children = group.children || []
        children.forEach((item) => {
          labels.push(
            item.name,
            item.key,
            item.label,
            item.fieldName,
            item.title,
            ...this.getReplacementFieldAliases(item.name),
            ...this.getReplacementFieldAliases(item.key),
            ...this.getReplacementFieldAliases(item.label),
            ...this.getReplacementFieldAliases(item.fieldName),
          )
        })
      })

      return new Set(
        labels
          .map((label) => this.normalizeReplacementContextText(label))
          .filter((label) => label.length >= 2),
      )
    },
    hasConflictingReplacementFieldLabel(text, range, item, knownFieldLabels) {
      const nearbyLabel = this.getNearbyReplacementFieldLabel(text, range, knownFieldLabels)
      if (!nearbyLabel) return false

      const targetLabels = new Set(
        (item.fieldLabelCandidates || [])
          .map((label) => this.normalizeReplacementContextText(label))
          .filter(Boolean),
      )
      return !targetLabels.has(nearbyLabel)
    },
    getNearbyReplacementFieldLabel(text, range, knownFieldLabels) {
      const beforeText = text.slice(Math.max(0, range.start - 48), range.start)
      const normalizedBefore = this.normalizeReplacementContextText(beforeText)
      if (!normalizedBefore) return ''

      return Array.from(knownFieldLabels)
        .filter((label) => normalizedBefore.endsWith(label))
        .sort((prev, next) => next.length - prev.length)[0] || ''
    },
    isStrongReplacementSource(value) {
      const text = this.cleanAiReplacementText(value)
      const digitCount = text.replace(/\D/g, '').length
      if (this.isNumericLikeValue(text)) return digitCount >= 6
      if (/[\u4e00-\u9fa5]/.test(text)) return text.length >= 4
      return text.length >= 5
    },
    isWeakReplacementSource(value) {
      const text = this.cleanAiReplacementText(value)
      if (!text) return true
      const normalizedText = this.normalizeReplacementContextText(text)
      const digitCount = text.replace(/\D/g, '').length
      if (this.isNumericLikeValue(text)) return digitCount < 6
      if (/[\u4e00-\u9fa5]/.test(text)) return normalizedText.length < 4
      return normalizedText.length < 5
    },
    getReplacementRangeScore(textNode, text, range, item) {
      const context = this.getReplacementRangeContext(textNode, text, range)
      let score = 0
      const sourceContext = this.normalizeReplacementContextText(item.sourceContext)
      if (sourceContext) {
        const sourceContextMatched = [
          context.local,
          context.block,
          context.row,
        ].some((contextText) => contextText.includes(sourceContext))
        if (sourceContextMatched) {
          score += 100
        }
      }

      const fieldScore = this.getReplacementLabelScore(context, item.fieldLabelCandidates, {
        before: 36,
        local: 24,
        block: 16,
        row: 14,
      })
      const groupScore = this.getReplacementLabelScore(context, item.groupLabelCandidates, {
        before: 18,
        local: 14,
        block: 10,
        row: 8,
      })
      score += fieldScore
      if (!this.isWeakReplacementSource(item.sourceValue)) {
        score += groupScore
      }
      if (fieldScore && groupScore) score += 16
      return score
    },
    getReplacementRangeContext(textNode, text, range) {
      const before = text.slice(Math.max(0, range.start - 48), range.start)
      const after = text.slice(range.end, Math.min(text.length, range.end + 32))
      const local = `${before}${text.slice(range.start, range.end)}${after}`
      return {
        before: this.normalizeReplacementContextText(before),
        local: this.normalizeReplacementContextText(local),
        block: this.normalizeReplacementContextText(
          this.getClosestReplacementContextText(textNode, 'p,li,td,th,div'),
        ),
        row: this.normalizeReplacementContextText(
          this.getClosestReplacementContextText(textNode, 'tr'),
        ),
      }
    },
    getClosestReplacementContextText(textNode, selector) {
      const element = textNode?.parentElement?.closest?.(selector)
      if (!element) return ''
      const text = element.textContent || ''
      return text.length > 800 ? '' : text
    },
    getReplacementLabelScore(context, labels = [], weights = {}) {
      return labels.reduce((score, label) => {
        const normalizedLabel = this.normalizeReplacementContextText(label)
        if (!normalizedLabel) return score
        if (context.before.includes(normalizedLabel)) return Math.max(score, weights.before || 0)
        if (context.local.includes(normalizedLabel)) return Math.max(score, weights.local || 0)
        if (context.block.includes(normalizedLabel)) return Math.max(score, weights.block || 0)
        if (context.row.includes(normalizedLabel)) return Math.max(score, weights.row || 0)
        return score
      }, 0)
    },
    normalizeReplacementContextText(value) {
      return String(value || '')
        .replace(/[（）()[\]【】{}<>《》,，.。;；:：/\\\-\s]/g, '')
        .toLowerCase()
    },
    findReplacementRanges(text, sourceValue, isNumeric = false) {
      if (!text || !sourceValue) return []
      const ranges = []
      if (!isNumeric) {
        let cursor = 0
        while (cursor < text.length) {
          const start = text.indexOf(sourceValue, cursor)
          if (start === -1) break
          ranges.push({
            start,
            end: start + sourceValue.length,
          })
          cursor = start + sourceValue.length
        }
        return ranges
      }

      const pattern = new RegExp(`(^|[^\\d.])(${this.escapeRegExp(sourceValue)})(?=$|[^\\d.])`, 'g')
      let match = pattern.exec(text)
      while (match) {
        const start = match.index + match[1].length
        ranges.push({
          start,
          end: start + match[2].length,
        })
        if (pattern.lastIndex <= match.index) {
          pattern.lastIndex = match.index + 1
        }
        match = pattern.exec(text)
      }
      return ranges
    },
    isRangeOverlap(prev, next) {
      return prev.start < next.end && next.start < prev.end
    },
    escapeRegExp(value) {
      return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    },
    parseMaybeJson(value) {
      if (typeof value !== 'string') return value
      const text = value.trim()
      if (!text) return value
      if (!text.startsWith('{') && !text.startsWith('[')) return value
      try {
        return JSON.parse(text)
      } catch (error) {
        return value
      }
    },
    normalizeAiValue(value) {
      if (value && typeof value === 'object' && !Array.isArray(value)) {
        const valueKeys = ['value', 'content', 'text', 'result', 'numbers', 'amount', 'date']
        for (const key of valueKeys) {
          if (value[key] !== undefined && value[key] !== null && value[key] !== '') {
            return value[key]
          }
        }
      }
      return value
    },
    getErrorMessage(error) {
      return error?.message ? `（${error.message}）` : ''
    },
    getContractNameFromFileName(fileName = '') {
      const name = String(fileName).replace(/\.[^.]+$/, '').trim()
      return name ? name.slice(0, 50) : this.getDefaultContractName()
    },
    getDefaultContractName() {
      const now = new Date()
      const pad = (num) => String(num).padStart(2, '0')
      return `合同模板-${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}`
    },
    saveDraftAiUuid(uuid = '') {
      if (this.isEdit) return
      setLocalStorage(this.storageAiUuidKeyAdd, uuid || '')
    },
    ensureContractName() {
      if (this.contractName && this.contractName.trim()) return
      if (this.contractImport.fileName) {
        this.contractName = this.getContractNameFromFileName(this.contractImport.fileName)
        return
      }
      const text = (this.getEditorContent({ format: 'text' }) || '')
        .split(/\r?\n/)
        .map((item) => item.trim())
        .find(Boolean)
      this.contractName = text ? text.slice(0, 50) : this.getDefaultContractName()
    },
    getTemplateIdFromResponse(data) {
      if (data === undefined || data === null || data === '') return ''
      if (typeof data === 'number' || typeof data === 'string') return data
      return data.id || data.templateId || data.contractTemplateId || ''
    },
    buildContractTemplateParams(saveDraft) {
      this.sendContractContent = this.getSubmitContractContent()
      const params = {
        name: this.contractName,
        contractContent: this.sendContractContent,
        state: saveDraft === 'saveDraft' ? -1 : 1,
      }
      const templateId = this.contractTemplateId || this.id || this.$route.query.id
      if (this.isEdit || templateId) {
        params.id = Number(templateId)
        params.dimension =
          this.$route.name === GROUP_CONTRACT_TEMPLATE_PREVIEW ? 1 : 2
      }
      if (this.moduleName &&
      this.moduleName === contractTemplateModule.entrustWithholdContractTemplate) {
        params.bizType = 2
      }
      return params
    },
    async saveContractTemplate(saveDraft, options = {}) {
      this.ensureContractName()
      if (!this.getFormValidate()) return ''

      const { keepOnPage = false, silent = false } = options
      const loadingKey = saveDraft === 'saveDraft' ? 'saveDraft' : this.turnalFlag
      this.oLoading[loadingKey] = true
      const params = this.buildContractTemplateParams(saveDraft)
      const ajaxAction = params.id ? contractTmpEdit : contractTmpAdd

      try {
        const { code, data } = await ajaxAction(params)
        if (code !== 1) return ''

        const templateId = this.getTemplateIdFromResponse(data) || params.id
        if (templateId) {
          this.contractTemplateId = templateId
          this.id = Number(templateId)
        }

        if (!silent) {
          this.$message.success(
            this.isAdd || this.isCopy ? '操作成功' : '修改成功',
          )
        }

        if (!keepOnPage) {
          if (saveDraft !== 'saveDraft') {
            this.$emit('submitSuccess', templateId)
          }
          this.$router.push({
            path: '/tenantNew/contractTemplate/list',
          })
        }
        return templateId
      } finally {
        this.oLoading[loadingKey] = false
      }
    },
    prepareLeasePlanAfterTemplateSaved(templateId) {
      this.contractTemplateId = templateId
      this.$refs.leasePlanForm?.prepareAfterTemplateSaved?.(templateId)
    },
    async submitLeasePlan() {
      if (this.oLoading.submitLeasePlan) return
      this.oLoading.submitLeasePlan = true
      try {
        const success = await this.$refs.leasePlanForm?.submit?.()
        if (success) {
          this.$emit('submitSuccess', this.contractTemplateId)
          this.$router.push({
            path: '/tenantNew/contractTemplate/list',
          })
        }
      } finally {
        this.oLoading.submitLeasePlan = false
      }
    },
    contractTmpFixedContent() {
      contractTmpFixedContentApi({ bizType: 2 }).then((res) => {
        if (res) {
          const { code, data } = res
          if (code === 1) {
            if (Array.isArray(data)) {
              let content = ''
              data.forEach((item) => {
                content += item.contractContent
              })

              this.contractContent = content
              this.$nextTick(() => {
                this.setEditorContent(this.contractContent, { updateStorage: false })
              })
            }
          }
        }
      })
    },
    // 提取提交事件
    handleSubmit: throttle(async function (saveDraft) {
      if (saveDraft === 'saveDraft') {
        await this.saveContractTemplate(saveDraft)
        return
      }
      if (this.currentStep === 1) {
        if (!this.needLeasePlanStep) {
          await this.saveContractTemplate()
          return
        }
        const templateId = await this.saveContractTemplate('', {
          keepOnPage: true,
        })
        if (!templateId) return
        this.prepareLeasePlanAfterTemplateSaved(templateId)
        this.enterRentalPlanStep()
        return
      }
      await this.submitLeasePlan()
    }, 3000, { trailing: false }),

    // 获取表单验证效果
    getFormValidate() {
      this.contractContent = this.getEditorContent()
      if (this.activeTab === '1') {
        this.sendContractContent = this.getSubmitContractContent()
      }
      if (!this.contractName.trim()) {
        this.$message.error('模板名称不能为空')
        return false
      }

      if (!this.contractContent.trim() || !this.sendContractContent.trim()) {
        this.$message.error('模板内容不能为空')
        return false
      }
      return true
    },
    // 请求详情接口
    async contractTmpPreview() {
      if (this.moduleName === contractTemplateModule.entrustWithholdContractTemplate) {
        this.isReq = true
      }
      if (!this.id) return
      const params = {
        id: this.id,
      }

      if (this.moduleName &&
      this.moduleName === contractTemplateModule.entrustWithholdContractTemplate) {
        params.bizType = 2
      }
      const { code, data } = await contractTmpPreview(params)
      if (code === 1) {
        this.getEditor()?.execCommand('mceCleanup')
        this.contractName = data.name
        // 解析模版渲染 table数据
        this.contractContent = data.contractContent
        this.sendContractContent = data.contractContent
        this.validResult = {
          valid: data.valid,
          reason: data.reason,
        }
        this.$nextTick(() => {
          this.setEditorContent(this.contractContent)
        })
      }
    },

    // 获取草稿
    getDraftContent(savedContent, savedTitleName, savedAiUuid = '') {
      // 防御性检查：确保 savedContent 不为 null/undefined
      if (!savedContent) {
        this.contractName = savedTitleName || ''
        if (savedAiUuid) {
          this.contractImport.aiUuid = savedAiUuid
          this.contractImport.analysisData = {}
        }
        return
      }
      this.getEditor()?.execCommand('mceCleanup')
      try {
        this.contractContent = savedContent
        this.sendContractContent = savedContent
        this.contractName = savedTitleName || ''
        if (savedAiUuid) {
          this.contractImport.aiUuid = savedAiUuid
          this.contractImport.analysisData = {}
        }
        this.$nextTick(() => {
          this.setEditorContent(savedContent)
        })
      } catch (error) {
        this.contractImport.warnings = [error?.message || '从本地存储恢复内容失败']
      }
    },

    // 合同模板动态字段查询接口
    async selectVar() {
      const params = {}
      if (this.moduleName &&
          this.moduleName === contractTemplateModule.entrustWithholdContractTemplate) {
        params.bizType = 2
      }
      const { code, data } = await contractTmpVariables(params)
      if (code === 1) {
        this.keywords = data
        this.checkItems = data.map((item) => item.title)
      }
    },
    async confirmSelect() {
      if (!this.checkKey) {
        this.$message.error('请先选取对应的key')
        return false
      }
      const [index, ind] = this.checkKey
      const item =
        this.keywords[index] &&
        this.keywords[index].children &&
        this.keywords[index].children[ind]
      const key = item && item.name
      const group = this.keywords[index] || {}

      if (!key) return false

      // 插入系统字段
      this.getEditor()?.execCommand(
        'mceInsertContent',
        false,
        this.createPlaceholderHtml({
          fieldName: key,
          groupName: group.title || group.name || group.label || '',
          fieldValue: item?.example || '',
          displayLabel: this.buildPlaceholderLabel(key),
        }),
      )
      this.$nextTick(() => {
        this.updateContentStats()
      })
    },
    // 点击参数变量
    handleClickSystemVar(index, ind) {
      this.checkKey = [index, ind]
      this.confirmSelect()
    },
    // 页面返回
    pageGoBack(status = false) {
      this.isReq = false
      this.$refreshBack(status) // 关闭当前tab
    },
  },
}
</script>
<style lang="scss" scoped>
.app-main {
  overflow: hidden !important;
}
::v-deep .el-collapse-item__content {
  padding: 16px 14px;
}
.add-contract-temp {
  .contract-ai-loading-mask {
    position: fixed;
    inset: 0;
    z-index: 3000;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(31, 35, 41, 0.45);
  }

  .contract-ai-loading-panel {
    width: 400px;
    min-height: 188px;
    padding: 38px 32px 34px;
    box-sizing: border-box;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 18px 42px rgba(0, 0, 0, 0.18);
    text-align: center;
  }

  .contract-ai-loading-spinner {
    width: 46px;
    height: 46px;
    margin: 0 auto 20px;
    border: 3px solid #e5e7eb;
    border-bottom-color: #2d6cdf;
    border-radius: 50%;
    animation: contract-ai-spin 0.9s linear infinite;
  }

  .contract-ai-loading-title {
    color: #1f2329;
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
  }

  .contract-ai-loading-text {
    margin-top: 12px;
    color: #9aa3b2;
    font-size: 14px;
    line-height: 22px;
  }

  .contract-stepper {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    min-height: 72px;
    padding-top: 18px;
  }
  .contract-step {
    width: 136px;
    text-align: center;
    color: #9aa3b2;

    &.active,
    &.completed {
      color: #2d6cdf;

      .contract-step-number {
        color: #fff;
        border-color: #2d6cdf;
        background: #2d6cdf;
        box-shadow: 0 2px 8px rgba(45, 108, 223, 0.28);
      }
    }
  }
  .contract-step-number {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    margin: 0 auto 8px;
    border: 1px solid #dcdfe6;
    border-radius: 50%;
    background: #f5f7fa;
    color: #b3bac6;
    font-size: 16px;
    font-weight: 600;
    line-height: 38px;
  }
  .contract-step-label {
    font-size: 14px;
    line-height: 20px;
  }
  .contract-step-line {
    width: 150px;
    height: 1px;
    margin-top: 19px;
    background: #dcdfe6;
  }
  .temp_content {
    .temp_content_header {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      .form-box {
        flex: 1;
        ::v-deep .el-form-item {
          margin-bottom: 0;
        }
      }
    }
  }
  .contract-template-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
  }
  .contract-import-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  }
  .docx-input {
    display: none;
  }
  ::v-deep .contract-invalid-dialog {
    border-radius: 12px;
    overflow: hidden;

    .el-dialog__header {
      padding: 28px 34px 24px;
      border-bottom: 1px solid #ebeef5;
    }

    .el-dialog__body {
      padding: 34px 34px 30px;
    }

    .el-dialog__footer {
      padding: 20px 34px 22px;
      border-top: 1px solid #ebeef5;
      text-align: center;
    }
  }

  .contract-invalid-dialog__title {
    display: flex;
    align-items: center;
    color: #1f2329;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
  }

  .contract-invalid-dialog__icon {
    margin-right: 8px;
    color: #f00000;
    font-size: 28px;
    font-weight: 700;
  }

  .contract-invalid-dialog__summary {
    margin-bottom: 28px;
    color: #cf3d4c;
    font-size: 22px;
    font-weight: 600;
    line-height: 34px;
  }

  .contract-invalid-dialog__reason {
    padding: 22px 20px 24px;
    border: 1px solid #f3b9bf;
    border-radius: 8px;
    background: #fff6f7;
    color: #7a2931;
    font-size: 18px;
    line-height: 32px;
  }

  .contract-invalid-dialog__reason-title {
    margin-bottom: 14px;
    font-weight: 600;
  }

  .contract-invalid-dialog__reason-text {
    white-space: pre-wrap;
    word-break: break-word;
  }

  .contract-invalid-dialog__footer {
    display: flex;
    justify-content: center;
    gap: 16px;

    ::v-deep .el-button {
      min-width: 92px;
      height: 40px;
      padding: 0 22px;
      font-size: 16px;
    }
  }
  ::v-deep .w-e-text-container {
    height: calc(100vh - 340px) !important;
  }
  ::v-deep .w-e-full-screen-editor .w-e-text-container {
    height: calc(100vh - 42px) !important;
  }
}

@keyframes contract-ai-spin {
  to {
    transform: rotate(360deg);
  }
}

.editor-container{
  display: flex;
  flex-direction: row;
  .edit{
    display: flex;
    min-width: 0;
    flex: 1;
    flex-direction: column;
  }
}
.contract-editor-tip {
  margin: -4px 0 8px;
  color: #909399;
  font-size: 13px;
  line-height: 20px;
}
.contract-editor-stats {
  padding: 6px 10px;
  border: 1px solid #dcdfe6;
  border-top: 0;
  border-radius: 0 0 4px 4px;
  background: #fff;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}
.editor-box {
  margin: 0 0 0 3px;
  border: 1px solid #ccc;
  width: 380px;
  height: 550px;
  overflow-y: auto;
  background: #fff;
  &-header {
    padding: 0 10px;
    line-height: 28px;
    font-size: 14px;
    color: #417de6;
    font-weight: 600;
    > span {
      color: red;
      font-size: 12px;
    }
  }
}
.replaced-field-panel {
  border-bottom: 1px solid #ebeef5;
}
.replaced-field-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #1f2329;
}
.replaced-field-count {
  min-width: 22px;
  height: 18px;
  padding: 0 6px;
  border-radius: 9px;
  background: #dff7ea;
  color: #18a058 !important;
  font-size: 12px !important;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
}
.system-field-title {
  margin-top: 8px;
}
.replaced-empty {
  padding: 12px 0;
  color: #909399;
  font-size: 12px;
  text-align: center;
}
.replaced-field-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.replaced-field-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 36px;
  padding: 6px 8px;
  border-radius: 4px;
  background: #f7f8fa;
}
.replaced-field-info {
  display: grid;
  grid-template-columns: minmax(72px, 1fr) minmax(54px, 76px) minmax(54px, 90px);
  align-items: center;
  gap: 6px;
  min-width: 0;
  flex: 1;
  font-size: 12px;
  line-height: 18px;
}
.replaced-field-name {
  color: #303133;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.replaced-field-group,
.replaced-field-value {
  color: #909399;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.check-item {
  padding: 0 0 3px 0px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  span {
    display: inline-block;
    font-size: 12px;
    line-height: 24px;
  }
  span:first-of-type {
    font-size: 14px;
    height: 24px;
    width: 200px;
  }
  span:last-of-type {
    flex: 1;
    text-align: left;
    word-wrap: break-word;
    word-break: break-all;
  }
  img{
    display: inline-block;
    width: 40%;
  }
  img:hover {
    transform:  translate(-60px) scale(2) ;
    transition: all 0.1s ease-in-out;
  }
}
.ai-error-tip {
  width: 100%;
  background: #F7F8FA;
  border-radius: 4px;
  padding: 12px 16px;
  box-sizing: border-box;

  .ai-tag-wrapper {
    display: inline-flex;
    align-items: center;
    background: #FFECE8;
    border-radius: 2px;
    padding: 3px 6px 3px 4px;
    margin-bottom: 8px;

    .ai-prefix {
      background: #C21F3A;
      color: #fff;
      font-size: 12px;
      padding: 0 4px;
      border-radius: 2px;
      height: 16px;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 6px;
      font-weight: 600;
    }

    .ai-suffix {
      color: #C21F3A;
      font-size: 12px;
      font-weight: 500;
      line-height: 1;
    }
  }

  .error-text {
    font-size: 14px;
    color: #F56C6C;
    line-height: 22px;
  }
}
::v-deep .placeholder-config-dialog {
  border-radius: 10px;
  overflow: hidden;

  .el-dialog__header {
    padding: 22px 24px 18px;
    border-bottom: 1px solid #ebeef5;
  }

  .el-dialog__title {
    color: #1f2329;
    font-size: 16px;
    font-weight: 600;
  }

  .el-dialog__body {
    padding: 22px 24px 10px;
  }

  .el-dialog__footer {
    padding: 16px 24px;
    border-top: 1px solid #ebeef5;
  }
}
.placeholder-config-form {
  ::v-deep .el-form-item {
    margin-bottom: 16px;
  }

  ::v-deep .el-form-item__label {
    padding-bottom: 6px;
    color: #303133;
    line-height: 20px;
  }
}
</style>
